import Image1 from '../../assets/images/why-us-hero.jpeg';

export const WhyUsContent = {
    heroBreadCrumb: {
        image: Image1,
        header: 'WHY CHOOSE RAYKOS',
        description: 'Discover the key differentiators that set RAYKOS apart in the pharmaceutical industry'
    },
    paragraph1: {
        header: "Why RAYKOS?",
        description: `
            <p>Raykos is a Breed Apart!</p>
            <p>Raykos is not a mere product supplier!!</p>
            <p>Raykos is indeed your technical partner!!!</p>
        `
    },
    stepperContent: {
        header: `<span class="title-bar">Why Us</span>`,
        itemsList: [
          {
            name: "Quality Products",
            value:
              "We are committed to producing high-quality medications that meet stringent regulatory standards, ensuring safety and efficacy for patients.",
          },
          {
            name: "Research Excellence",
            value:
              "Our experienced R&D team is at the forefront of innovation, continuously developing new and improved treatments to address unmet medical needs.",
          },
          {
            name: "State-of-the-Art Facilities",
            value:
              "Our advanced manufacturing facilities leverage cutting-edge technology, enabling us to deliver products of the highest quality and reliability.",
          },
          {
            name: "Commitment to Ethics",
            value:
              "We uphold the highest ethical standards, ensuring transparency, integrity, and responsible business practices in all our operations.",
          },
          {
            name: "Customer-Centric Approach",
            value:
              "We prioritize our customers' needs and strive to exceed their expectations by providing exceptional service, timely delivery, and personalized support.",
          },
          {
            name: "Global Reach",
            value:
              "With a strong global network, we have the capability to serve customers and patients in various regions, contributing to better healthcare access worldwide.",
          },
          {
            name: "Collaboration Opportunities",
            value:
              "We actively seek collaborations and partnerships to drive innovation, expand our product portfolio, and address healthcare challenges collectively.",
          },
          {
            name: "Consulting & Technical Support",
            value:
              "We provide expert consulting and technical support to partners and customers — from formulation and process optimization to regulatory guidance and scale-up assistance, helping projects succeed at every stage.",
          },
        ],
    },
    sectionBanner: {
        description:
          "Have any question, contact us.",
        button: {
          url: "/contact",
          name: "Contact US",
        },
    }
}
